import React from 'react';
import PropTypes from 'prop-types';
import { GeozoneAddItem } from './GeozoneAddItem';
import { GeozoneItem } from './GeozoneItem';

export const GeozonesList = ({ geozones, onCreateHandler, onDeleteHandler, onEditHandler, onActivateHandler }) =>
  (<ul className="garage-list">
    {geozones.map(geozone => (
      <GeozoneItem
        key={geozone.id}
        geozone={geozone}
        onActivate={(e) => { e.preventDefault(); onActivateHandler(geozone); }}
        onEdit={(e) => { e.preventDefault(); onEditHandler(geozone); }}
        onDelete={(e) => { e.preventDefault(); onDeleteHandler(geozone); }}
      />))}
    <GeozoneAddItem onAddClick={onCreateHandler} />
  </ul>);

GeozonesList.propTypes = {
  geozones: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
  })).isRequired,
  onCreateHandler: PropTypes.func.isRequired,
  onDeleteHandler: PropTypes.func.isRequired,
  onEditHandler: PropTypes.func.isRequired,
  onActivateHandler: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Modal/SettingsModal/Geozones/GeozonesList.js